export default "__VITE_ASSET__BEIKH7BD__"